import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { AuthService } from '../../service/auth.service';
import { EcomicService } from '../../service/comics/ecomic.service';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {
  AddUserForm: FormGroup;
  loading: boolean = false;
  load: boolean = false;
  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private comicService: EcomicService,
    private afAuth: AngularFireAuth,
    private route: ActivatedRoute, private auth: AuthService, public toastr: ToastsManager, vcr: ViewContainerRef,private http:HttpClient) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    this.initForm();
  }
initForm(){
  this.AddUserForm = this.form.group({
    name: ['', [Validators.required]],
    email: ['', [Validators.required]],
    phone:['',[Validators.required]],
    password: ['',[Validators.required]],
  });
}
AddNewUser(value, valid){
  if (valid) {
  this.loading = true;
  const uservalue ={
    name: value.name,
    email: value.email,
    phone: value.phone,
    password: value.password,
    mode:"Mail",
    isFirstLogin:true,
    createdAt: new Date().toLocaleDateString()
    }
    this.AddUser(uservalue).then((response:any)=>{
      this.loading = false;
      this.toastr.success('User Added Successfully!', 'Success!');
      this.AddUserForm.reset();
    }).catch(error=>{
      console.log(error);
      this.loading = false;
      this.toastr.error(error.message, 'Error!');
    })
  }
}
async AddUser(user) {
  const uservalue ={
    name: user.name,
    email: user.email,
    phone: user.phone,
    isFirstLogin:true,
    password: user.password,
    mode:"Mail",
    id:"",
    createdAt: new Date().toLocaleDateString()
  }
  return new Promise((resolve, reject) =>{
    this.afAuth.auth.createUserWithEmailAndPassword(user.email, user.password).then(async (response:any)=>{
      console.log(response)
       uservalue.id = response.uid;
     this.afs.collection('users').doc(response.uid).set(uservalue).then((user:any)=>{
      resolve(user);
     });
     
    }).catch(error=>{
      reject(error);
    });
  });
}
}



// WEBPACK FOOTER //
// ./src/app/users/add-user/add-user.component.ts